/* Play, Learn, Grow: small behaviour enhancements
   1. hero video quality + homepage video autoplay (with sound when the browser allows it)
   2. content pages: About becomes colour cards, FAQs become an accordion, email links work
   3. Shop Buckets page title
   4. product pages: a short trust strip under the buy buttons
   5. Afrikaans: translates the text typed into the theme editor, and adds a language button for phones
   6. cart: prices without the redundant currency code (R 399.00 instead of R 399.00 ZAR)
   Wording follows the page language (English or Afrikaans). */
(function () {
  'use strict';

  var IS_AF = (document.documentElement.lang || '').toLowerCase().indexOf('af') === 0;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Videos ---------- */
  function setupVideos() {
    document.querySelectorAll('video.hero__media').forEach(function (v) {
      v.preload = 'auto';
      v.setAttribute('playsinline', '');
    });

    var vid = document.querySelector('video[class*="ai-video-element-"]');
    if (!vid) return;

    var wrap = vid.parentElement;
    vid.loop = true;
    vid.preload = 'auto';
    vid.setAttribute('playsinline', '');

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'plg-sound-pill';
    pill.hidden = true;
    pill.setAttribute('aria-label', IS_AF ? 'Skakel klank aan' : 'Turn sound on');
    pill.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg><span>' +
      (IS_AF ? 'Tik vir klank' : 'Tap for sound') +
      '</span>';
    wrap.appendChild(pill);

    var inView = false;
    var activated = false;

    function syncIcons() {
      var muteIcon = wrap.querySelector('[class*="ai-mute-icon-"]');
      var unmuteIcon = wrap.querySelector('[class*="ai-unmute-icon-"]');
      if (muteIcon && unmuteIcon) {
        muteIcon.style.display = vid.muted ? 'block' : 'none';
        unmuteIcon.style.display = vid.muted ? 'none' : 'block';
      }
    }

    function syncPill() {
      pill.hidden = !(vid.muted && !vid.paused);
    }

    function safePlay() {
      var p = vid.play();
      return p && p.catch ? p : Promise.resolve();
    }

    function start() {
      vid.muted = !activated;
      safePlay()
        .catch(function () {
          vid.muted = true;
          return safePlay().catch(function () {});
        })
        .then(function () {
          syncIcons();
          syncPill();
        });
    }

    function unmute() {
      activated = true;
      if (inView && vid.muted) {
        vid.muted = false;
        if (vid.paused) safePlay().catch(function () {});
      }
    }

    ['pointerdown', 'touchend', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, unmute, { passive: true });
    });

    pill.addEventListener('click', function (e) {
      e.stopPropagation();
      activated = true;
      vid.muted = false;
      safePlay().catch(function () {});
    });

    ['play', 'pause', 'volumechange'].forEach(function (evt) {
      vid.addEventListener(evt, function () {
        syncIcons();
        syncPill();
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView) start();
            else vid.pause();
          });
        },
        { threshold: 0.5 }
      ).observe(vid);
    } else {
      inView = true;
      start();
    }
  }

  /* ---------- Content pages ---------- */
  var EMAIL = /^[^\s@\/:]+@[^\s@\/:]+\.[^\s@\/:]+$/;

  function fixEmailLinks(scope) {
    scope.querySelectorAll('a').forEach(function (a) {
      var href = a.getAttribute('href');
      var text = a.textContent.trim();
      if (href && EMAIL.test(href)) a.setAttribute('href', 'mailto:' + href);
      else if (!href && EMAIL.test(text)) a.setAttribute('href', 'mailto:' + text);
    });
  }

  function isQuestion(el) {
    return (
      el &&
      el.tagName === 'P' &&
      el.children.length === 1 &&
      el.firstElementChild.tagName === 'STRONG' &&
      el.textContent.trim() === el.firstElementChild.textContent.trim()
    );
  }

  function enhanceContentPage() {
    var main = document.getElementById('MainContent');
    if (!main || (main.dataset.template || '').indexOf('page') !== 0) return;

    fixEmailLinks(main);

    var rte = main.querySelector('rte-formatter');
    if (!rte || rte.dataset.plgEnhanced) return;

    var groups = [[]];
    Array.prototype.slice.call(rte.children).forEach(function (el) {
      if (el.tagName === 'HR') groups.push([]);
      else groups[groups.length - 1].push(el);
    });
    groups = groups.filter(function (g) {
      return g.length;
    });
    if (groups.length < 2) return;

    var isFaq = /faq|frequently/i.test(location.pathname);
    var wrap = document.createElement('div');
    wrap.className = isFaq ? 'plg-faq' : 'plg-page';
    var cardIndex = 0;

    groups.forEach(function (g) {
      var first = g[0];

      if (isFaq && isQuestion(first)) {
        var details = document.createElement('details');
        var summary = document.createElement('summary');
        summary.textContent = first.textContent.trim();
        var answer = document.createElement('div');
        answer.className = 'plg-faq__answer';
        g.slice(1).forEach(function (el) {
          answer.appendChild(el);
        });
        details.appendChild(summary);
        details.appendChild(answer);
        wrap.appendChild(details);
      } else if (!isFaq && /^H[1-3]$/.test(first.tagName)) {
        var card = document.createElement('section');
        card.className = 'plg-card plg-card--' + (cardIndex % 6);
        cardIndex += 1;
        g.forEach(function (el) {
          card.appendChild(el);
        });
        wrap.appendChild(card);
      } else {
        var lead = document.createElement('div');
        lead.className = 'plg-lead';
        g.forEach(function (el) {
          lead.appendChild(el);
        });
        wrap.appendChild(lead);
      }
    });

    rte.dataset.plgEnhanced = 'true';
    rte.innerHTML = '';
    rte.appendChild(wrap);
  }

  /* ---------- Shop Buckets page ---------- */
  function renameShopPage() {
    if (!/\/collections\/all\/?$/.test(location.pathname)) return;
    var h1 = document.querySelector('#MainContent h1');
    if (h1 && /^(products|produkte)$/i.test(h1.textContent.trim())) {
      h1.textContent = IS_AF ? 'Koop emmertjies' : 'Shop Buckets';
    }
  }

  /* ---------- Product pages ---------- */
  function addProductTrust() {
    var main = document.getElementById('MainContent');
    if (!main || (main.dataset.template || '').indexOf('product') !== 0) return;
    if (main.querySelector('.plg-trust')) return;

    var pay = main.querySelector('[class*="ai-payment-icon-"]');
    var host = pay ? pay.closest('.shopify-block') : main.querySelector('.buy-buttons-block');
    if (!host) return;

    var attrs = 'viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    var items = [
      ['#e84aa9', '<path d="M12 21s-8-5.3-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 5.7-8 11-8 11z"/>', IS_AF ? "Ontwerp deur 'n arbeidsterapeut" : 'Designed by an Occupational Therapist'],
      ['#2a6fd6', '<path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/>', IS_AF ? 'Landwyd afgelewer regoor Suid-Afrika' : 'Delivered nationwide across South Africa'],
      ['#2f9e66', '<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6z"/><path d="m9 12 2 2 4-4"/>', IS_AF ? 'Veilige afhandeling' : 'Secure checkout']
    ];

    var ul = document.createElement('ul');
    ul.className = 'plg-trust';
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.innerHTML = '<svg ' + attrs + ' stroke="' + it[0] + '">' + it[1] + '</svg><span>' + it[2] + '</span>';
      ul.appendChild(li);
    });
    host.insertAdjacentElement('afterend', ul);
  }

  /* ---------- Afrikaans: text typed into the theme editor ----------
     Keys are the English wording exactly as it appears on the page. If the English wording is
     changed in the editor, add the new wording here (or translate it in Shopify's Translate & Adapt).
     ­ is an invisible soft hyphen: it lets a very long word break neatly inside a small card. */
  var AF_TEXT = {
    'We deliver nationwide': 'Ons lewer landwyd af',
    'Educational buckets available in Afrikaans & English': 'Opvoedkundige emmertjies beskikbaar in Afrikaans en Engels',
    'Play based learning tools designed by an Occupational Therapist to support development and school readiness.': "Speelgebaseerde leerhulpmiddels wat deur 'n arbeidsterapeut ontwerp is om ontwikkeling en skoolgereedheid te ondersteun.",
    'Shop now': 'Koop nou',
    'Shop': 'Winkel',
    'Send': 'Stuur',
    'Our Educational Buckets': 'Ons opvoedkundige emmertjies',
    'View Product': 'Bekyk produk',
    'What Can You Expect from Our Educational Buckets': 'Wat kan jy van ons opvoedkundige emmertjies verwag',
    'Our educational buckets are thoughtfully designed by a qualified Occupational Therapist to support early childhood development through play. Each activity is crafted to nurture essential skills while keeping learning fun and engaging.': "Ons opvoedkundige emmertjies is deurdag ontwerp deur 'n gekwalifiseerde arbeidsterapeut om vroeë kinderontwikkeling deur spel te ondersteun. Elke aktiwiteit is geskep om noodsaaklike vaardighede te koester terwyl leer prettig en boeiend bly.",
    'Through play, children learn to explore, build confidence, and develop the foundational skills they need for school readiness. Every bucket is an opportunity to grow, discover, and thrive.': "Deur spel leer kinders om te verken, selfvertroue te bou en die grondliggende vaardighede te ontwikkel wat hulle vir skoolgereedheid nodig het. Elke emmertjie is 'n geleentheid om te groei, te ontdek en te blom.",
    'Fine motor skills': 'Fynmotoriese vaardighede',
    'Hand eye coordination': 'Hand-oog koördinasie',
    'Bilateral coordination': 'Bilaterale koördinasie',
    'Attention and concentration': 'Aandag en konsentrasie',
    'Visual motor integration': 'Visueel-motoriese integrasie',
    'Problem solving skills': 'Probleem­oplossings­vaardighede',
    'Emotional awareness': 'Emosionele bewustheid',
    'Body awareness': 'Liggaams­bewustheid',
    'About me': 'Oor my',
    "Hi, I'm Courtney Campbell, a qualified Occupational Therapist with a special interest in early childhood development.": "Hallo, ek is Courtney Campbell, 'n gekwalifiseerde arbeidsterapeut met 'n spesiale belangstelling in vroeë kinderontwikkeling.",
    "I'm passionate about helping children reach their full potential and believe that children learn best through play. Through my experience working with children, I have seen that when learning is fun, engaging, and meaningful, children truly thrive.": "Ek is passievol daaroor om kinders te help om hul volle potensiaal te bereik en glo dat kinders die beste deur spel leer. Deur my ervaring met kinders het ek gesien dat kinders werklik blom wanneer leer pret, boeiend en betekenisvol is.",
    'This inspired me to create educational buckets, play based tools designed to support learning, development, and school readiness in a practical and engaging way.': "Dit het my geïnspireer om opvoedkundige emmertjies te skep, speelgebaseerde hulpmiddels wat ontwerp is om leer, ontwikkeling en skoolgereedheid op 'n praktiese en boeiende manier te ondersteun.",
    'Learn more': 'Leer meer',
    'How It Works': 'Hoe dit werk',
    'Choose your bucket': 'Kies jou emmertjie',
    "Browse our collection and select the perfect learning bucket for your child's age and interests.": "Blaai deur ons versameling en kies die perfekte leeremmertjie vir jou kind se ouderdom en belangstellings.",
    'Place your order': 'Plaas jou bestelling',
    "Complete your purchase securely and we'll prepare your bucket with care and attention.": 'Voltooi jou aankoop veilig en ons berei jou emmertjie met sorg en aandag voor.',
    'Start learning through play': 'Begin leer deur spel',
    'Receive your bucket and watch your child explore, learn, and grow through engaging activities.': 'Ontvang jou emmertjie en kyk hoe jou kind deur boeiende aktiwiteite verken, leer en groei.',
    'Choose Your Bucket': 'Kies jou emmertjie',
    'Support Every Child with Confidence': 'Ondersteun elke kind met selfvertroue',
    "Practical, expert led training for teachers and parents to better support children's development.": "Praktiese opleiding deur kundiges vir onderwysers en ouers om kinders se ontwikkeling beter te ondersteun.",
    'Explore Training': 'Verken opleiding',
    'Led by a qualified Occupational Therapist': "Aangebied deur 'n gekwalifiseerde arbeidsterapeut",
    "Have questions? We're here to help.": 'Het jy vrae? Ons is hier om te help.',
    'What are the educational buckets?': 'Wat is die opvoedkundige emmertjies?',
    "Educational buckets are play based learning kits designed by a qualified Occupational Therapist to support children's development through fun, hands on activities.": "Opvoedkundige emmertjies is speelgebaseerde leerpakkette wat deur 'n gekwalifiseerde arbeidsterapeut ontwerp is om kinders se ontwikkeling deur prettige, praktiese aktiwiteite te ondersteun.",
    'What age group are the buckets suitable for?': 'Vir watter ouderdomsgroep is die emmertjies geskik?',
    'Suitable for children aged 3 to 7 years, with activities that can be adapted to different needs.': 'Geskik vir kinders van 3 tot 7 jaar, met aktiwiteite wat by verskillende behoeftes aangepas kan word.',
    'What skills do the buckets help develop?': 'Watter vaardighede help die emmertjies ontwikkel?',
    'Fine motor skills, hand eye coordination, bilateral coordination, attention and concentration, visual perception, and school readiness.': 'Fynmotoriese vaardighede, hand-oog koördinasie, bilaterale koördinasie, aandag en konsentrasie, visuele persepsie en skoolgereedheid.',
    'Are the buckets available in different languages?': 'Is die emmertjies in verskillende tale beskikbaar?',
    'Yes, available in English and Afrikaans.': 'Ja, beskikbaar in Engels en Afrikaans.',
    'Are the buckets suitable for all learners?': 'Is die emmertjies geskik vir alle leerders?',
    'Yes, activities can be adapted for different developmental levels and learning needs.': 'Ja, aktiwiteite kan aangepas word vir verskillende ontwikkelingsvlakke en leerbehoeftes.',
    'Do you offer training for schools, teachers, or parents?': 'Bied julle opleiding vir skole, onderwysers of ouers aan?',
    'Yes, training is available with practical strategies. Contact via email to arrange.': 'Ja, opleiding is beskikbaar met praktiese strategieë. Kontak ons per e-pos om dit te reël.',
    'How long does it take to process an order?': "Hoe lank neem dit om 'n bestelling te verwerk?",
    'Orders are processed within 3 to 5 working days.': 'Bestellings word binne 3 tot 5 werksdae verwerk.',
    'Do you deliver?': 'Lewer julle af?',
    'Yes, delivery is available nationwide across South Africa.': 'Ja, aflewering is landwyd regoor Suid-Afrika beskikbaar.',
    'How can I request a quotation for school or bulk orders?': "Hoe kan ek 'n kwotasie vir skool- of grootmaatbestellings aanvra?",
    'Contact via email to request a quotation.': "Kontak ons per e-pos om 'n kwotasie aan te vra.",
    'Do you have a physical store?': "Het julle 'n fisiese winkel?",
    'No, this is an online store.': "Nee, dit is 'n aanlynwinkel.",
    'Request bulk order': 'Versoek grootmaatbestelling',
    'Shop The Full Collection': 'Koop die volledige versameling',
    'Page not found': 'Bladsy nie gevind nie',
    'The link may be incorrect, or the page has been removed.': 'Die skakel mag verkeerd wees, of die bladsy is verwyder.',
    'Continue shopping': 'Gaan voort met inkopies',
    'You may also like': 'Jy sal dalk ook hou van',
    'Customers are saying': 'Wat kliënte sê',
    'Let customers speak for us': 'Laat kliënte vir ons praat',
    'Availability': 'Beskikbaarheid',
    'In stock': 'Op voorraad',
    'Out of stock': 'Nie op voorraad nie',
    'Price': 'Prys',
    'Featured': 'Voorgestel',
    'Most relevant': 'Mees relevant',
    'Best selling': 'Topverkoper',
    'Alphabetically, A-Z': 'Alfabeties, A-Z',
    'Alphabetically, Z-A': 'Alfabeties, Z-A',
    'Price, low to high': 'Prys, laag na hoog',
    'Price, high to low': 'Prys, hoog na laag',
    'Date, old to new': 'Datum, oud na nuut',
    'Date, new to old': 'Datum, nuut na oud',
    'Privacy policy': 'Privaatheidsbeleid',
    'Contact information': 'Kontakbesonderhede',
    'Terms of service': 'Diensbepalings',
    'Refund policy': 'Terugbetalingsbeleid',
    'Shipping policy': 'Afleweringsbeleid'
  };

  function normText(s) {
    return s.replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim();
  }

  var AF_LOOKUP = {};
  Object.keys(AF_TEXT).forEach(function (k) {
    AF_LOOKUP[normText(k)] = AF_TEXT[k];
  });

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  function translateTree(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var p = n.parentNode;
      if (!p || SKIP[p.nodeName]) return;
      var raw = n.nodeValue;
      var key = normText(raw);
      if (!key || !Object.prototype.hasOwnProperty.call(AF_LOOKUP, key)) return;
      var lead = raw.match(/^\s*/)[0];
      var trail = raw.match(/\s*$/)[0];
      n.nodeValue = lead + AF_LOOKUP[key] + trail;
    });
  }

  /* ---------- Cart: drop the redundant currency code from prices ---------- */
  var CART_SCOPE = '.cart-drawer__dialog, cart-items-component, .cart-items-component, .cart-totals, .cart-form, .sticky-add-to-cart';

  function stripCurrencyCode(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      if (!/\sZAR\s*$/.test(n.nodeValue)) return;
      var p = n.parentNode;
      if (!p || SKIP[p.nodeName] || !p.closest || !p.closest(CART_SCOPE)) return;
      n.nodeValue = n.nodeValue.replace(/\s+ZAR(\s*)$/, '$1');
    });
  }

  function setupLiveText() {
    if (IS_AF) translateTree(document.body);
    stripCurrencyCode(document.body);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (IS_AF) translateTree(document.body);
        stripCurrencyCode(document.body);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Language button (phones; desktop already has the header dropdown) ---------- */
  function addLanguageButton() {
    var hasAf = /^\/af(\/|$)/.test(location.pathname);
    var right = document.querySelector('header .header__column--right');
    if (!right || right.querySelector('.plg-lang')) return;
    if (!document.querySelector('localization-form-component')) return;

    var path = location.pathname.replace(/^\/af(?=\/|$)/, '') || '/';
    var target = hasAf ? path : '/af' + (path === '/' ? '' : path);
    var a = document.createElement('a');
    a.className = 'plg-lang';
    a.href = target + location.search;
    a.textContent = hasAf ? 'EN' : 'AF';
    a.setAttribute('hreflang', hasAf ? 'en' : 'af');
    a.setAttribute('lang', hasAf ? 'en' : 'af');
    a.setAttribute('aria-label', hasAf ? 'Switch to English' : 'Wissel na Afrikaans');
    right.insertBefore(a, right.firstChild);

    var style = document.createElement('style');
    style.textContent =
      '.plg-lang{display:none;align-items:center;justify-content:center;width:44px;height:44px;border-radius:50%;background:#ffe9f6;color:#241a2b;font-weight:700;font-size:13px;letter-spacing:.02em;text-decoration:none}' +
      '.plg-lang:hover{background:#ffd93d}' +
      '@media (max-width:749px){.plg-lang{display:inline-flex}}';
    document.head.appendChild(style);
  }

  ready(function () {
    setupVideos();
    enhanceContentPage();
    renameShopPage();
    addProductTrust();
    setupLiveText();
    addLanguageButton();
  });
})();
